import { getWorkspaceProjectTabTitle } from '@/hooks/workspaceTabProjectTitleCache';

/**
 * 项目工作空间内根据 URL 参数解析「当前项目」。
 * 名称优先使用页签标题缓存（进入工作台后由 showMedProject 写入）；缺省回退为占位文案。
 *
 * @param {string | undefined} id
 * @returns {{ id: string, name: string, status: string, type: string } | null}
 */
export function getWorkspaceProjectById(id) {
    if (id == null || id === '') {
        return null;
    }
    const cachedName = getWorkspaceProjectTabTitle(id);
    return {
        id: String(id),
        name: cachedName || `项目 ${id}`,
        status: 'active',
        type: 'default',
    };
}
